import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  width: calc(100% - 40rem);
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.s}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    justify-content: center;
  }
`;
